import {useCallback, useEffect, useMemo, useState} from "react";
import {IPollInfo} from "../constants/IPollInfo";
import {GameStatuses} from "../constants/GameStatuses";

const formGameTime = (time: {hours: number, minutes: number, seconds: number}) => {

    const getDoubleNumber = (num: number) => num > 9 ? num : '0' + num;

    return getDoubleNumber(time.hours) + ':' + getDoubleNumber(time.minutes) + ':' + getDoubleNumber(time.seconds);
}

export const useGameTimer = (pollInfo?: IPollInfo, customStartTime?: number) => {

    const [timeUntilEnd, setTimeUntilEnd] = useState<{hours: number, minutes: number, seconds: number}>({hours: 0, minutes: 0, seconds: 0});
    const [timeOffset, setTimeOffset] = useState(0);
    const stageDate = useMemo(() => pollInfo?.stages[(pollInfo?.stages?.length || 1) - 1]?.start || "", [pollInfo]);
    const stageTime = useMemo(() =>  pollInfo?.stages[(pollInfo?.stages?.length || 1) - 1]?.stageSeconds || 0, [pollInfo]);
    const startTime = useMemo(() =>  stageDate ? new Date(stageDate)?.getTime() : (customStartTime || 0), [stageDate, customStartTime]);
    const isGameActive = useMemo(() => pollInfo?.status === GameStatuses.active, [pollInfo]);
    useEffect(() => {
    const syncTime = async () => {
        try {
            const response = await fetch('/api/server-time', {
                method: 'HEAD',
                cache: 'no-store'
            });
             const dateHeader = response.headers.get('date');
            
            // Проверяем, что заголовок существует
            if (!dateHeader) {
                setTimeOffset(0);
                return;
            }
            const serverTime = new Date(dateHeader).getTime();
            const localTime = Date.now();
            setTimeOffset(serverTime - localTime);
        } catch (error) {
            setTimeOffset(0);
        }
    };
    syncTime();
}, []);
    
    const isDisabled = useMemo(() => (Boolean(!stageDate) && Boolean(!customStartTime)) || !isGameActive, [stageDate, customStartTime, isGameActive]);

    const setActualTime = useCallback(() => {
        const currentTime = Date.now() + timeOffset;
        const timeDifference = Math.round((currentTime - startTime) / 1000)

        // он всегда отстает на 2 секунды, потому вычитаем
        const timeUntil = (stageDate || customStartTime) ? stageTime - timeDifference : stageTime;
        const timeUntilFiltered = timeUntil < 0 ? 0 : timeUntil;

        setTimeUntilEnd({
            hours: Math.floor(timeUntilFiltered / (60 * 60)),
            minutes: Math.floor((timeUntilFiltered / 60) % 60),
            seconds: Math.floor(timeUntilFiltered % 60),
        })
    }, [customStartTime, stageDate, stageTime, startTime])
    
    useEffect(() => {
        if (!pollInfo?.stages) return;
        if (!stageTime && !customStartTime) return;

        if (!isGameActive) {
            setTimeUntilEnd({
                hours: 0,
                minutes: 0,
                seconds: 0,
            })
            return;
        }

        setActualTime();

    }, [pollInfo, customStartTime, stageTime, stageDate, isGameActive, setActualTime])

    useEffect(() => {

        if (isDisabled) return;
        
        const timeout = setInterval(setActualTime, 1000)

        return () => clearInterval(timeout);

    }, [isDisabled, setActualTime])

    return formGameTime(timeUntilEnd);
}import {useCallback, useEffect, useMemo, useState} from "react";
import {IPollInfo} from "../constants/IPollInfo";
import {GameStatuses} from "../constants/GameStatuses";

const formGameTime = (time: {hours: number, minutes: number, seconds: number}) => {

    const getDoubleNumber = (num: number) => num > 9 ? num : '0' + num;

    return getDoubleNumber(time.hours) + ':' + getDoubleNumber(time.minutes) + ':' + getDoubleNumber(time.seconds);
}

export const useGameTimer = (pollInfo?: IPollInfo, customStartTime?: number) => {

    const [timeUntilEnd, setTimeUntilEnd] = useState<{hours: number, minutes: number, seconds: number}>({hours: 0, minutes: 0, seconds: 0});
    const [timeOffset, setTimeOffset] = useState(0);
    const stageDate = useMemo(() => pollInfo?.stages[(pollInfo?.stages?.length || 1) - 1]?.start || "", [pollInfo]);
    const stageTime = useMemo(() =>  pollInfo?.stages[(pollInfo?.stages?.length || 1) - 1]?.stageSeconds || 0, [pollInfo]);
    const startTime = useMemo(() =>  stageDate ? new Date(stageDate)?.getTime() : (customStartTime || 0), [stageDate, customStartTime]);
    const isGameActive = useMemo(() => pollInfo?.status === GameStatuses.active, [pollInfo]);
    useEffect(() => {
    const syncTime = async () => {
        try {
            const response = await fetch('/api/server-time', {
                method: 'HEAD',
                cache: 'no-store'
            });
             const dateHeader = response.headers.get('date');
            
            // Проверяем, что заголовок существует
            if (!dateHeader) {
                setTimeOffset(0);
                return;
            }
            const serverTime = new Date(dateHeader).getTime();
            const localTime = Date.now();
            setTimeOffset(serverTime - localTime);
        } catch (error) {
            setTimeOffset(0);
        }
    };
    syncTime();
}, []);
    
    const isDisabled = useMemo(() => (Boolean(!stageDate) && Boolean(!customStartTime)) || !isGameActive, [stageDate, customStartTime, isGameActive]);

    const setActualTime = useCallback(() => {
        const currentTime = Date.now() + timeOffset;
        const timeDifference = Math.round((currentTime - startTime) / 1000)

        // он всегда отстает на 2 секунды, потому вычитаем
        const timeUntil = (stageDate || customStartTime) ? stageTime - timeDifference : stageTime;
        const timeUntilFiltered = timeUntil < 0 ? 0 : timeUntil;

        setTimeUntilEnd({
            hours: Math.floor(timeUntilFiltered / (60 * 60)),
            minutes: Math.floor((timeUntilFiltered / 60) % 60),
            seconds: Math.floor(timeUntilFiltered % 60),
        })
    }, [customStartTime, stageDate, stageTime, startTime])
    
    useEffect(() => {
        if (!pollInfo?.stages) return;
        if (!stageTime && !customStartTime) return;

        if (!isGameActive) {
            setTimeUntilEnd({
                hours: 0,
                minutes: 0,
                seconds: 0,
            })
            return;
        }

        setActualTime();

    }, [pollInfo, customStartTime, stageTime, stageDate, isGameActive, setActualTime])

    useEffect(() => {

        if (isDisabled) return;
        
        const timeout = setInterval(setActualTime, 1000)

        return () => clearInterval(timeout);

    }, [isDisabled, setActualTime])

    return formGameTime(timeUntilEnd);
}